<nav class="bottom-nav glass-panel--strong" aria-label="ناوبری اصلی" role="tablist" aria-orientation="horizontal">
  @for (item of navItems; track item.path; let i = $index) {
    <button
      role="tab"
      [routerLink]="item.path"
      routerLinkActive="bottom-nav__item--active"
      class="bottom-nav__item"
      [class.bottom-nav__item--home]="item.path === '/dashboard'"
      [attr.aria-label]="item.label"
      [attr.aria-selected]="router.url === item.path"
      [attr.aria-controls]="router.url === item.path ? item.path + '-panel' : null"
      [id]="router.url === item.path ? 'tab-' + item.path.substring(1) : null"
      appHapticFeedback="selection"
      data-cuelume-toggle="toggle"
    >
      <span class="bottom-nav__icon" aria-hidden="true">
        <img [src]="item.iconPath" [alt]="item.alt" class="icon-plumpy" />
      </span>
      <span class="bottom-nav__label">{{ item.label }}</span>
    </button>
  }
</nav>
